export default __webpack_public_path__ + "static/media/myPhoto.50993d2f.jpg";